import(/* webpackMode: "eager" */ "/code/app/(site-with-hero)/legal/legal.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/components/legal/LegalTableOfContents.tsx");
